import { RootState } from 'store/rootSlices';

export const getCurricularPlanSlice = (state: RootState) => state.CurricularPlan;
export const getRegistration = (state: RootState) => state.StudentRegistrationDropdown.registration;
export const getUserRegistrations = (state: RootState) => state.App.user.registrations;
export const getUserNmec = (state: RootState) => state.App.user.nmec;
export const getUser = (state: RootState) => state.App.user;
export const getAppSlice = (state: RootState) => state.App.currentLocale;
